import React from 'react';

const LeftColumn = ({ children }) => (
  <div className="relative w-full bg-white flex flex-col gap-5 p-5 mx-auto max-w-3xl sm:gap-7 lg:p-12 lg:col-span-8">
    {children}
  </div>
);
export default LeftColumn;
